import { render } from "./ActivityCommentForm.vue?vue&type=template&id=d2d4da14&scoped=true"
import script from "./ActivityCommentForm.vue?vue&type=script&lang=js"
export * from "./ActivityCommentForm.vue?vue&type=script&lang=js"

import "./ActivityCommentForm.vue?vue&type=style&index=0&id=d2d4da14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d2d4da14"

export default script